import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Alert, Button } from '@hh.ru/magritte-ui';
import { ExclamationTriangleFilledSize24 } from '@hh.ru/magritte-ui-icon/icon';

const TrlKeys = {
    title: 'career-platform.page-cert-landing.section.screens.alert-only-desktop.title',
    description: 'career-platform.page-cert-landing.section.screens.alert-only-desktop.description',
    confirm: 'career-platform.page-cert-landing.section.screens.alert-only-desktop.confirm',
};

interface Props {
    visible: boolean;
    onClose: () => void;
}

const AlertOnlyDesktop: TranslatedComponent<Props> = ({ visible, onClose, trls }) => (
    <Alert
        visible={visible}
        title={trls[TrlKeys.title]}
        description={trls[TrlKeys.description]}
        layout="vertical"
        icon={<ExclamationTriangleFilledSize24 />}
        iconStyle="warning"
        buttons={
            <Button mode="primary" style="accent" stretched onClick={onClose}>
                {trls[TrlKeys.confirm]}
            </Button>
        }
        onClose={onClose}
    />
);

export default translation(AlertOnlyDesktop);
